import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { Meta } from '@angular/platform-browser';

import axios from 'src/app/Service/axios';

import * as XLSX from 'xlsx';

declare let $: any;

@Component({

  selector: 'app-without-planning-report',

  templateUrl: './without-planning-report.component.html',

  styleUrls: ['./without-planning-report.component.css']

})

export class WithoutPlanningReportComponent implements OnInit {

  lstCars = [];

  lstRoutes = [];

  lst_Reports = [];

  lst_Search = [];

  lst_GeoFence = [];

  lstMobileType = [];

  totalTravel: number | string = 0;

  totalTime: number | string = 0;

  totalStop: number | string = 0;

  totalStopTime: number | string = 0;

  mdl_Search: FormGroup = this.FormBuilder.group({

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    ID: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    lststrUnitID: new FormControl([]),

    lstiSGeoFence: new FormControl([]),

    lstiDGeoFence: new FormControl([]),

    lsttiMobileType: new FormControl([]),

    iMintPresenceTime: new FormControl(''),

    iMaxPresenceTime: new FormControl(''),

  });

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _other: OtherService,

    private metaService: Meta

  ) { }

  ngOnInit(): void {

    this.getGeoFence();

    this.getMobileType();

    this.getCars();

    this.getRoutes();

  }

  getMobileType = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`GetMobileType_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstMobileType = res;

  }

  getGeoFence = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`Radyab_GeoFence`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_GeoFence = res;

  }

  getCars = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = (await axios.post(`FleetYar_Car_List_New`, this._other.stringNumberToNumber(model))).data;

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstCars = res;

  }

  getRoutes = async () => {

    let model = this.mdl_Search.value;

    this._other.Showspinner()

    let res = JSON.parse((await axios.post(`TransitRoute_List`, this._other.stringNumberToNumber(model))).data.toString());

    this._other.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstRoutes = res;

  }

  search_Report = async () => {

    if (this.mdl_Search.invalid) {

      return this._tooltip.showError('تاریخ شروع و پایان را مشخص کنید')

    }

    else {

      let model = this.mdl_Search.value;

      this._other.Showspinner()

      let res = JSON.parse((await axios.post(`GeoFence_OriginDestination_MobilesReport`, this._other.stringNumberToNumber(model))).data.toString());

      this._other.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_Reports = res;

      this.lst_Search = res;

      this.totalTime = 0;

      this.totalTravel = 0;

      this.totalStop = 0;

      this.totalStopTime = 0;

      this.lst_Reports.forEach((el: any) => {

        this.totalTime += el.iTime;

        this.totalTravel += el.fNavigationKM;

        this.totalStop += el.iStops;

        this.totalStopTime += el.iStopsTime;

      })


      this.totalTravel = this.totalTravel.toFixed(2);

      this.totalTime = this.formattedTime(this.totalTime);

      this.totalStopTime = this.formattedTime(this.totalStopTime);

    }

  }

  formattedTime(input: number | string): string {

    const totalSeconds = Math.max(0, Math.floor(Number(input) || 0));

    const hours = Math.floor(totalSeconds / 3600);

    const minutes = Math.floor((totalSeconds % 3600) / 60);

    const seconds = totalSeconds % 60;

    const pad = (n: number) => String(n).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;

  }

  analyze = async () => {

    if (this.mdl_Search.invalid) {

      return this._tooltip.showError('تاریخ شروع و پایان را مشخص کنید')

    }

    else {

      $.confirm({

        title: `آیا از انجام این عملیات اطمینان دارید ؟`,

        content: 'با اجرای این فرمان، تحلیل های قبلی با مقدیر جدید جایگزین می شود',

        type: 'blue',

        buttons: {

          ok: {

            text: "تایید",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              let model = this.mdl_Search.value;

              this._other.Showspinner()

              let res = JSON.parse((await axios.post(`GeoFence_OriginDestination_MobilesAnalyze`, this._other.stringNumberToNumber(model))).data.toString());

              this._other.nonespinner();

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_Reports = res;

              this.lst_Search = res;

              this.totalTime = 0;

              this.totalTravel = 0;

              this.totalStop = 0;

              this.totalStopTime = 0;

              this.lst_Reports.forEach((el: any) => {

                this.totalTime += el.iTime;

                this.totalTravel += el.fNavigation_km;

                this.totalStop += el.iStops;

                this.totalStopTime += el.iStopTime;

              })

              this.totalTime = this.formattedTime(this.totalTime);

              this.totalStopTime = this.formattedTime(this.totalTime);

            }

          },

          cancel: {

            text: "لغو",


          }

        }

      });

    }

  }

  remove_Analyze = async () => {

    if (this.mdl_Search.invalid) {

      return this._tooltip.showError('تاریخ شروع و پایان را مشخص کنید')

    }

    else {

      $.confirm({

        title: `آیا از انجام این عملیات اطمینان دارید ؟`,

        content: 'با اجرای این فرمان، تمام تحلیل ها حذف می شوند',

        type: 'red',

        buttons: {

          ok: {

            text: "تایید",

            btnClass: 'btn-danger',

            keys: ['enter'],

            action: async () => {

              let model = this.mdl_Search.value;

              this._other.Showspinner()

              let res = JSON.parse((await axios.post(`GeoFence_OriginDestination_MobilesAnalyzeDelete`, this._other.stringNumberToNumber(model))).data.toString());

              this._other.nonespinner();

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_Reports = res;

              this.lst_Search = res;

              this.totalTime = 0;

              this.totalTravel = 0;

              this.totalStop = 0;

              this.totalStopTime = 0;

              this.totalTime = this.formattedTime(this.totalTime);

              this.totalStopTime = this.formattedTime(this.totalTime);

            }

          },

          cancel: {

            text: "لغو",


          }

        }

      });

    }

  }

  openRoute_Stops(item) {

    window.open(`/transit/route-stops/${item.iTransit_Trip}`, '_blank')

  }

  open_Location(item) {

    const url = this.router.serializeUrl(this.router.createUrlTree([`route/${item.strUnitID}`]))

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(item.strDate));

    window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strEnterTime));

    // window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strFullEnterTime));

    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(item.strExitTime));

    // window.localStorage.setItem("reportEtime", this.gurdService.encrypt(item.strFullExitTime));

    window.open(url, '_blank');


  }

  filter_list(val: any) {

    this.lst_Reports = this.lst_Search.filter((el: any) => {

      return el.strGeoFenceName.includes(val.value) ||

        el.strNexFeoFenceName.includes(val.value) ||

        el.strMobileType_strComment.includes(val.value) ||

        el.strFullName.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Reports = this.lst_Search;

    }

  }

  exportExcel(): void {
    /* pass here the table id */
    let element = document.getElementById(`Export_Excel`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, `گزارش عملکرد آزاد.xlsx`);
  }


}


